<template>
  <div>
    <h2>
      <v-icon color="accent">{{icono}}</v-icon>
      {{titulo}}
    </h2>
    <br>
    <v-form v-model="valid" ref="form">
    <v-layout row wrap>
      <v-flex xs12 sm10 md10 lg10 class="pr-2">
        <v-layout row wrap>
          <v-flex xs2 sm2 md2 lg2>
            <strong class="mr-1">ID</strong>
          </v-flex>
          <v-flex xs6 sm6 md6 lg6>
            <strong>{{ user.id}}</strong>
          </v-flex>
        </v-layout>
        <v-select
          label="Grupo"
          v-model="selectedGroup"
          :items="grupos"
          item-value="id"
          item-text="name"
          :rules="[v => !!v || 'El Grupo es requerido']"
          required
        ></v-select>
        <v-text-field
          label="Username"
          trim
          v-model="user.username"
          :rules="usernameRules"
          :counter="45"
          required
          :error-messages="usernameErrors"
        ></v-text-field>
        <v-text-field
          label="E-mail"
          v-model.lazy="user.email"
          :rules="emailRules"
          :error-messages="emailErrors"
          required
        ></v-text-field>
        <v-text-field
          v-if="accion == 1"
          name="Password"
          label="Password"
          hint="Mayor a 8 caracteres y que incluya mayusculas, minusculas y caracteres especiales"
          v-model="user.password"
          min="8"
          :append-icon="e1 ? 'visibility' : 'visibility_off'"
          :append-icon-cb="() => (e1 = !e1)"
          :type="e1 ? 'password' : 'text'"
          :rules="[v => (v && v.length >= 8) || 'El password debe ser de al menos 8 caracteres']"
          counter
        ></v-text-field>
        <v-checkbox
          label="Activo"
          v-model="user.active"
        ></v-checkbox>

        <v-layout row wrap>
          <v-flex xs6 sm4>
            <span class="mr-3">Fecha de Creación</span>
          </v-flex>
          <v-flex xs6 sm5>
            <span class="info--text">{{ user.fechaCreacion | date}}</span>
          </v-flex>
          <v-flex xs6 sm4>
            <span class="mr-3">Fecha de Actualización</span>
          </v-flex>
          <v-flex xs6 sm5>
            <span class="info--text">{{ user.fechaActualizacion | date}}</span>
          </v-flex>
          <v-flex xs6 sm4>
            <span class="mr-3">Usuario Creación</span>
          </v-flex>
          <v-flex xs6 sm5>
            <span v-if="user.usuarioCreacion" class="info--text">{{ user.usuarioCreacion.username}}</span>
          </v-flex>
          <v-flex xs6 sm4>
            <span class="mr-3">Propietario</span>
          </v-flex>
          <v-flex xs6 sm5>
            <span v-if="user.propietario" class="info--text">{{ user.propietario.username}}</span>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm2 md2 lg2>
        <v-btn
          block
          @click="submit"
          :disabled="!valid || (usernameErrors.length > 0) || (emailErrors.length > 0)"
          color="success"
        >
          <v-icon v-if="accion == 1" small left>fas fa-plus</v-icon>
          <v-icon v-if="accion == 2" small left>fas fa-edit</v-icon>
          <span v-show="accion == 1">Agregar</span>
          <span v-show="accion == 2">Actualizar</span>
        </v-btn>
        <v-btn @click="dialogoEliminar()" block color="error" v-show="accion == 2" :disabled="user.username === 'admin'">
          <v-icon left small>fas fa-trash-alt</v-icon>
          Eliminar
        </v-btn>
        <v-btn @click="cancelar" block >
          <v-icon left small>fas fa-chevron-left</v-icon>
          cancelar
        </v-btn>
      </v-flex>

    </v-layout>
    </v-form>

    <v-dialog v-model="dialog3" max-width="400px">
        <v-card>
          <v-card-title>
            <span>Confirme que desea eliminar el registro</span>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-actions>
            <v-btn color="error" @click.stop="eliminar()">
              <v-icon left small>fas fa-trash-alt</v-icon>
              Aceptar
            </v-btn>
            <v-btn flat @click.stop="dialog3=false">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

  </div>
</template>

<script>
import Usuarios from '../../services/usuarios'
import Grupos from '../../services/grupos'

export default {
  name: 'UsuarioDetalle',
  data () {
    return {
      titulo: 'Usuario Detalle',
      icono: 'fas fa-user',
      accion: null,
      e1: true,
      dialog3: false,
      grupos: [],
      user: { username: '', active: true},
      valid: false,
      usernameRules: [
        v => !!v || 'Ingrese un nombre de usuario válido',
        v => (v && v.length <= 15) || 'El nombre debe ser menor a 15 caracteres'
      ],
      emailRules: [
        v => !!v || 'Ingrese una dirección de email',
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Ingrese una dirección email válida'
      ],
      selectedGroup: null,
      mensaje: false,
      usernameErrors: [],
      emailErrors: []
    }
  },
  methods: {
    async submit () {
      if (this.$refs.form.validate()) {
        this.user.group = this.selectedGroup
        if (this.accion === 1) {
          Usuarios.save(this.user)
          .then(res => {
            this.user = res
            this.accion = 2
            this.$emit('show-message', {msg: 'Registro Guardado', tipo: 'info'})
          })
          .catch(() => {
            this.$emit('show-message', {msg: 'Ocurrió un error, verifique la información', tipo: 'error'})
          })
        } else {
          Usuarios.update(this.user)
          .then(res => {
            this.user = res
            this.$emit('show-message', {msg: 'Registro Guardado', tipo: 'info'})
          })
          .catch(err => {
            this.$emit('show-message', {msg: 'Ocurrió un error, verifique la información', tipo: 'error'})
          })
        }
      }
    },
    async eliminar() {
      await Usuarios.delete(this.user.id)
      this.dialog3 = false
      this.$emit('show-message', 'Registro Eliminado')
      setTimeout(this.cancelar, 800)
    },
    cancelar () {
      this.$router.push('/usuarios')
    },
    dialogoEliminar() {
      this.dialog3 = true
    }
  },
  watch: {
    'user.username': _.debounce(async function (newV) {
      if (!newV || this.accion == 2) {
        this.usernameErrors = []
        return
      }
      let res = await Usuarios.list({ username: newV, populate: 'group' })
      if (res.length > 0) {
        this.usernameErrors = ['El nombre de usuario ya existe en el sistema']
      } else {
        this.usernameErrors = []
      }
    },500),
    'user.email': _.debounce(async function (newV) {
      if (!newV || this.accion == 2) {
        this.emailErrors = []
        return
      }
      let res = await Usuarios.list({ email: newV, populate: 'group' })
      if (res.length > 0) {
        this.emailErrors = ['La dirección de email ya existe en el sistema']
      } else {
        this.emailErrors = []
      }
    },500)
  },
  beforeMount: async function() {
    this.grupos = await Grupos.list({ populate: 'usuarioCreacion' })
    if (this.$route.params.id === '0') {
      this.accion = 1 //Agregar
    } else {
      this.accion = 2 //Actualizar
      this.user = await Usuarios.get(this.$route.params.id, { populate: 'usuarioCreacion,propietario'})
      if (this.user) {
        this.selectedGroup = this.user.group
      } else {
        this.cancelar()
      }
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/usuarios/UsuarioDetalle.vue